import { demoMovers, demoOverview, demoRankings, demoSync, demoTraffic } from "./demo";

const API_URL = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");
export const isDemoMode = import.meta.env.VITE_DEMO_MODE === "true" || !API_URL;

export interface QueryFilters {
  from?: string;
  to?: string;
  country?: string;
  projectId?: string;
  category?: string;
  query?: string;
  page?: number;
  pageSize?: number;
}

function queryString(filters: QueryFilters): string {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== "") params.set(key, String(value));
  });
  const value = params.toString();
  return value ? `?${value}` : "";
}

async function request<T>(path: string, fallback: T, init?: RequestInit): Promise<T> {
  if (isDemoMode) {
    await new Promise((resolve) => setTimeout(resolve, 180));
    return fallback;
  }
  const response = await fetch(`${API_URL}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...init
  });
  if (!response.ok) throw new Error(`API ${response.status}: ${response.statusText}`);
  const json = (await response.json()) as { data: T };
  return json.data;
}

export const seoApi = {
  overview: (filters: QueryFilters) =>
    request(`/api/v1/overview${queryString(filters)}`, demoOverview),
  rankings: (filters: QueryFilters) =>
    request(`/api/v1/rankings${queryString(filters)}`, demoRankings),
  traffic: (filters: QueryFilters) =>
    request(`/api/v1/traffic${queryString(filters)}`, demoTraffic),
  matrix: (filters: QueryFilters) =>
    request(`/api/v1/ranking-traffic${queryString(filters)}`, demoRankings),
  movers: (filters: QueryFilters) =>
    request(`/api/v1/movers${queryString(filters)}`, demoMovers),
  syncStatus: () => request("/api/v1/sync-status", demoSync),
  startSync: (backfillDays = 7) =>
    request(
      "/api/v1/sync",
      { runId: `demo-${Date.now()}`, status: "running" },
      { method: "POST", body: JSON.stringify({ backfillDays }) }
    )
};
